export enum fieldType {
	'text',
	'select', //autocomplete
	'selectBox',
	'radio',
	'datePicker',
	'textArea',
	'dateRangePicker',
}

// for select use options

export interface option {
	value: string;
	label: string;
	disabled?: boolean;
}

export interface fieldProps {
	name: string;
	value?: string | number | null;
	defaultValue?: string | number;
	options?: Array<option>;
	error?: boolean;
	helperText?: string;
	placeholder?: string;
	label?: string;
	required?: boolean;
	handleChange?: any;
	handleValidation?: any;
	disabled?: boolean;
	type?: string;
	autoselect?: string;
	sx?: any;
	regex?: any;
	maxLength?: number,
	minLength?:  number,
	formatAsAmount?: boolean,
}

export enum validationTypes {
	requierd = 'requierd',
	duplicatefields = 'duplicate',
	email = 'email',
	website = 'website',
	phone = 'phone',
	match = 'match',
  checked = 'checked',
	lettersOnly = 'lettersOnly',
	cityName = 'cityName',
  digits = 'digits',
  float = 'float',
	id = 'id',
	balance = 'balance',
	min3Chars = 'min3Chars',
	min5Chars = 'min5Chars',
	hebrewLettersOnly = 'hebrewLettersOnly',
	minAmount = 'minAmount',
  maxAmount = 'maxAmount',
	englishAndHebrewLettersOnly = 'englishAndHebrewLettersOnly',
  englishAndHebrewLettersAndDigits = 'englishAndHebrewLettersAndDigits',
	englishAndDigits = 'englishAndDigits', //english letters and numbers
  hebrewLettersSpecialChars='hebrewLettersSpecialChars',
  englishLettersSpecialChars='englishLettersSpecialChars',
  custom = 'custom',
	noDecimalAllowed = 'noDecimalAllowed',
	forbiddenCurrency = 'forbiddenCurrency'
}
export enum fieldsGroupType {
	row = 'row',
	col = 'column',
}
export interface fieldsGroup {
	type: fieldsGroupType;
	styleObj?: object;
	spacing?: number;
	fields: field[];
  title?: string;
}

export interface field {
	type: fieldType;
	props: fieldProps;
	validation?: validationTypes[];
	styleObj?: object;
	valueProperty?: string;
	labelProperty?: string;
	renderOption?: any;
	renderInput?: any;
	getOptionDisabled?: any;
	maxValue?: number;
}

export interface createFormProps {
	initialValidation?: { [key: string]: validationProps };
	name: string;
	handleChange: any;
	fieldsGroups: fieldsGroup[];
	validations?: { [key: string]: validationTypes[] };
  translation?: any;
}

export type validationProps = {
	name: string;
	valid: boolean;
	errorText: string;
};

export type invalidFields = { [key: string]: validationProps };
